import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { IPSAgent } from "../../../models/peer-support";
import { UIStyledTooltip } from "../../ui/UIComponents";
import { AgentActions, AgentActionsProps } from "./AgentActions";
import { PhoneLinkWeb } from "../../ui/PhoneLinkWeb";
import { EmailLinkWeb } from "../../ui/EmailLinkWeb";
import { UIAddress } from "../../google-maps/Address";
import { PSAdminContent } from "..";
import { UIPageTitle } from "../../ui/UIPageTitle";
import { Address } from "../../../laco-common/base/models/address";

export type AgentDetailProps = AgentActionsProps;

export const AgentDetail: React.FC<AgentDetailProps> = (props: AgentDetailProps) => {
	// const context: ILayoutContext = useContext(LayoutContext);
	const agent: IPSAgent = props.agent;

	const agentHeader = (
		<div className="container-fluid bg-gray1">
			<div className="container py-4_5">
				<div className="row">
					<div className="col-12 col-sm-5 col-md-4">
						<h2>
							{agent.first_name} {agent.last_name}
						</h2>
						{!!agent.title && (
							<div className="text-sm text-info" style={{ marginTop: "-5px", marginBottom: "5px" }}>
								{agent.title}
							</div>
						)}
						<UIStyledTooltip title="Back to peers">
							<NavLink to="ps/peers">
								<IconButton className="ui-icon-btn-floating mt-1" aria-label="Delete" size="small">
									<ArrowBackIcon />
								</IconButton>
							</NavLink>
						</UIStyledTooltip>
					</div>
					<div className="text-sm col-12 col-sm-4 col-md-5 mt-1 mb-3-mobile mt-4-mobile d-flex flex-column">
						<PhoneLinkWeb number={agent.mobile_number} className="mb-2" />
						<EmailLinkWeb className="mb-2" email={agent.email} />
					</div>
					<PSAdminContent uid={agent.uid}>
						<div className="col-12 col-sm-3 col-md-3">
							<h4 className="d-none d-md-inline-block mb-3">Actions</h4>
							<AgentActions {...props} omitLink={true} />
						</div>
					</PSAdminContent>
				</div>
			</div>
		</div>
	);

	const renderAddress = (address: Address, title: string, showZipOnly: "Yes" | "No"): React.ReactNode => {
		if (!address) return null;
		return (
			<div className="mb-4_5 mt-1 text-md detail-address col-12 col-md-5">
				<h4 className="text-success mb-1">{title}</h4>
				<UIAddress
					address={address}
					showZipOnly={showZipOnly}
					showMapOnHover={true}
					omitPin={true}
					iconStyles={{ marginTop: "4px" }}
				/>
			</div>
		);
	};

	return (
		<>
			<UIPageTitle pageTitle={`${agent.first_name} ${agent.last_name}`} />
			{agentHeader}
			<div className="container my-4_5">
				<div className="w-50 w-100-sm">
					<div className="row">
						{renderAddress(agent.workAddress, "Work", agent.showWorkZipCodeOnly)}
						<div className="d-none d-md-block col-md-2"></div>
						{renderAddress(agent.homeAddress, "Home", agent.showHomeZipCodeOnly)}
					</div>
					{!!agent.bio && (
						<>
							<h2 className="mb-3">Bio</h2>
							<p>{agent.bio}</p>
						</>
					)}
				</div>
			</div>
		</>
	);
};
